<template>
  <div class="my_container">
    <div class="my_breadcrumb_box">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ name: 'Home' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ name: 'DraftList' }">个人中心</el-breadcrumb-item>
        <el-breadcrumb-item>草稿详情</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="glag_left">
      <div class="text_detail_box">
        <div class="text_detail_title">{{detail.article_title}}</div>
        <div class="text_detail_author">{{detail.expert_name}}</div>
        <div class="text_detail_content" v-html="detail.article_content"></div>
      </div>
    </div>
    <div class="glag_right">
      <div class="title_top_hr">
        <p>
          <span>草稿箱列表</span>
          <el-divider></el-divider>
        </p>
      </div>
      <div class="expert_list_recommend_box">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      detail: {}
    }
  },
  created () {
    const vueThat = this
    const id = this.$route.params.id
    vueThat.myApi.draftDetail({ article_drafts_id: id }).then((res) => {
      if (res.data.code === 200) {
        vueThat.detail = res.data.data
      }
    })
  }
}
</script>

<style>
</style>
